import { rq } from 'http/apiRoutes';
import { useGet } from 'http/useApi';
import React from 'react';
import { useParams } from 'react-router';
import { IPackageViewModel } from '../../Interfaces/IPackageConfig';
import { PackageForm } from './PackageForm';

type Params = Record<string, string | undefined>;

export const Package: React.FC = () => {
  const { companyId, packageId } = useParams<Params>();

  // api
  let isEnabled = packageId !== 'new';

  const { data: packageData } = useGet(
    rq.package(companyId || '', packageId || '', isEnabled),
    
  );

  if (packageId === 'new') {
    return (
      <PackageForm
        packageData={{} as IPackageViewModel}
        isDefaultPackage={false}
      />
    );
  } else {
    return (
      !!packageData && (
        <PackageForm
          packageData={packageData as IPackageViewModel}
          isDefaultPackage={false}
        />
      )
    );
  }
};
